import { Text } from '@/components/shared/components/Text';
import { GetLoanDetailActionsByRoleProps } from '@/components/widgets/LoanDetailActions/types/GetLoanDetailActionsByRoleProps';
import { LoanDetailAction } from '@/components/widgets/LoanDetailActions/types/LoanDetailAction';
import { APP_ROLES } from '@/config/config';

export const getNotificationsRelatedActions = ({ toggleActionDialog, role }: GetLoanDetailActionsByRoleProps) => {
  if (!(role === APP_ROLES.ADMIN || role === APP_ROLES.SUPER_ADMIN || role === APP_ROLES.CPC_BACK_OFFICE)) return [];

  return [
    {
      display: <Text tId={'OPT_OUT_NOTIFICATIONS'} />,
      onClick: () => toggleActionDialog(LoanDetailAction.OPT_OUT_NOTIFICATIONS),
      iconName: 'notifications_off',
    },
  ];
};
